import { ref } from 'vue';

export default function useAutocomplete(fetchCallback: any, initialItems: any[] = []) {
  const loading = ref(false);
  const foundItems = ref(initialItems);

  let searchCache: string | null = null;
  let setTimeoutId: NodeJS.Timeout | null = null;

  const fetch = async (query: string) => {
    try {
      loading.value = true;
      foundItems.value = await fetchCallback(query);
    } finally {
      loading.value = false;
    }
  };

  const onSearch = (query: string | null, shouldSplit = true) => {
    const splittedQuery = shouldSplit ? (query?.split('-') || ['']).pop() as string: query || '';
    const searchQuery = splittedQuery.trim();

    if (!searchQuery || !searchQuery?.length || searchQuery === searchCache) return;
    if (setTimeoutId) clearTimeout(setTimeoutId);

    searchCache = searchQuery;
    setTimeoutId = setTimeout(() => fetch(searchQuery), 300);
  };

  return { loading, onSearch, foundItems };
}
